export function checkForValueInJson(json, value) {
	for (var key in json) {
		if (typeof json[key] === 'object') {
			return checkForValueInJson(json[key], value);
		} else if (json[key] === value) {
			return true;
		}
	}

	return false;
}
export function checkEmptyRequiredFields(form, fields) {
	let error = {};
	if (!fields && !form.hasOwnProperty('corporationName')) {
		// check for review aps modal
		const required = [
			'address1',
			'dateOfBirth',
			'firstName',
			'lastName',
			'occupation',
			'phoneNumber',
		];
		required.map((field) => {
			let value = form?.[field];
			let isEmpty = value?.trim().length === 0 || value === undefined;
			if (isEmpty) {
				error[field] = true;
			}
		});
	} else {
		fields &&
			fields.map((field) => {
				let value = form[field?.formName];
				let isEmpty = value?.trim().length === 0;
				if (field?.required === true && isEmpty) {
					error[field?.formName] = true;
				}
			});
	}
	if (form?.city === '' && form?.province === '' && form?.postalCode === '') {
		error.address1 = true;
	}
	return error; // {formName: T(empty)/F(filled)}
}
